export const home = {
  hero: {
    title1: 'Professional Film &',
    title2: 'Equipment Rental',
    title3: 'LensBank',
    subtitle: 'Trusted by professional filmmakers in Taiwan and beyond',
    cta1: 'Browse Equipment',
    cta2: 'Production Services'
  },
  services: {
    title: 'Core Services',
    equipment: {
      title: 'Professional Equipment Rental',
      desc: 'Over 1,000+ professional cinema and photography items for every production need',
      badge: '1,000+ Items'
    },
    taiwanJapan: {
      title: 'Taiwan–Japan Production',
      desc: 'Full cross-border production support: equipment, crew, and locations'
    },
    urent: {
      title: 'Urent Consignment',
      desc: 'Turn idle equipment into passive income with professional management'
    },
    postProduction: {
      title: 'Japan Post-production',
      desc: 'High-end commercial-grade editing and color grading services'
    },
    about: {
      title: 'About LensBank',
      desc: 'Over a decade of professional experience — your trusted creative partner'
    }
  },
  locations: {
    title: 'Our Locations',
    viewAll: 'View All Locations',
    store: 'Store',
    warehouse: 'Warehouse',
    hours: 'Business Hours',
    address: 'Address'
  },
  stats: {
    equipment: 'Equipment Items',
    locations: 'Service Locations',
    experience: 'Years of Experience',
    clients: 'Clients Served'
  }
};
